// extracted by mini-css-extract-plugin
export default {"container":"purchase-success_container__okCVe","message":"purchase-success_message__b33sv","email":"purchase-success_email__BVoRq"};